import React from "react";
import {
    Box,
    Container,
    Heading,
    Text,
    VStack,
} from "@chakra-ui/react";
import PublicNavbar from "../Landing/PublicNavbar";
import PublicFooter from "../Landing/PublicFooter";
import { WashiTape, DoodlePaperclip } from "../../CustomUi/DoodleIcons";
import { usePageTitle } from "../../../hooks/usePageTitle";

const PrivacyPage: React.FC = () => {
    usePageTitle(
        "Privacy Policy",
        "How Result by Numero protects student, school, and parent data in compliance with NDPR and international privacy standards."
    );
    return (
        <Box minH="100vh" bg="#FAF8F2">
            <PublicNavbar />

            <Box py={[12, 16]} className="notebook-dots">
                <Container maxW="4xl">
                    <Box
                        position="relative"
                        p={[6, 12]}
                        bg="white"
                        borderRadius="2xl"
                        border="3px solid #0A3D2E"
                        boxShadow="6px 8px 0px #0A3D2E"
                    >
                        <WashiTape angle={-3} top="-14px" left="36px" tapeColor="#FEF08A" label="Privacy &amp; Data 🛡️" />
                        <DoodlePaperclip color="#10B981" size={36} position="absolute" top="-16px" right="36px" />

                        <VStack align="start" gap={8} pt={2}>
                            <VStack align="start" gap={1}>
                                <Heading as="h1" fontSize={["2xl", "3xl", "4xl"]} fontWeight="extrabold" color="gray.900">
                                    Privacy Policy
                                </Heading>
                                <Text color="gray.500" fontSize="xs" fontWeight="bold">
                                    Last updated: November 2025 · Numero Technology Limited
                                </Text>
                            </VStack>

                            <VStack align="start" gap={6} color="gray.700" lineHeight="1.8" fontSize="sm">
                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        1. Introduction
                                    </Heading>
                                    <Text>
                                        Numero Technology Limited (&ldquo;we&rdquo;, &ldquo;our&rdquo;, or &ldquo;us&rdquo;), operators of Result, is dedicated to protecting student, parental, and school privacy. This policy outlines our collection, storage, and processing practices.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        2. Information We Process
                                    </Heading>
                                    <Text>
                                        We process data provided by schools, including staff user accounts, student academic records, continuous assessment scores, and payment receipts. All school financial processing is conducted in accordance with applicable Nigerian banking compliance.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        3. How We Use School Data
                                    </Heading>
                                    <Text>
                                        We use this data exclusively to compute academic marks, generate verified report cards, settle fees into designated school accounts, and transmit announcements. We do not sell or monetize student data.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        4. Security Safeguards
                                    </Heading>
                                    <Text>
                                        We maintain bank-grade SSL/TLS encryption, daily automated backups, and segmented access controls so only authorised school administrators and staff can access their respective records.
                                    </Text>
                                </Box>
                            </VStack>
                        </VStack>
                    </Box>
                </Container>
            </Box>

            <PublicFooter />
        </Box>
    );
};

export default PrivacyPage;
